/**
 * Resolves a raw JWT (no "Bearer " prefix) from the sources available to the
 * player, in priority order:
 *   1. LMS-hosted: `window.parent.__CFC_TOKEN__` (set by the LMS shell)
 *   2. Standalone: a token supplied to the app (auth0 access token or the
 *      `token` query param), passed in here as `fetchedToken`
 *   3. Local development: `process.env.CFC_TOKEN`
 *
 * Returns `null` when no token is available so callers can decide whether to
 * fail the request (e.g. curriculum-service requires authentication).
 *
 * @param {Object} [options]
 * @param {string} [options.fetchedToken] - standalone-mode token
 * @returns {string|null}
 */
export const getJwt = ({ fetchedToken } = {}) => {
  // 1. LMS-hosted mode
  try {
    const lmsToken = window?.parent?.__CFC_TOKEN__
    if (lmsToken) {
      return lmsToken
    }
  } catch (err) {
    // Cross-origin access to window.parent can throw; fall through.
    console.warn('Unable to read token from parent window', err)
  }

  // 2. Standalone mode token
  if (fetchedToken) {
    return fetchedToken
  }

  // 3. Local development env token
  if (process.env.CFC_TOKEN) {
    return process.env.CFC_TOKEN
  }

  return null
}
